<template>
	<v-container fill-height fluid>
		<v-row align="center" justify="center">
			<v-form
				v-model="valid"
				class="text-center"
				ref="form"
				@submit.prevent="login"
				style="max-width:unset !important; width:100% !important"
			>
				<img height="230" :src="require('../../assets/Emerald.png')" class="mb-3" />
				
				<!-- username -->
				<v-row
					class="justify-center align-center ma-0"
					style="width:100% !important;"
				>
					<v-col cols="auto" lg="3">
						<bee-text-field
							v-model="username"
							:label="$t('Login.username')"
							:autofocus="true"
							:rules="[rules.required]"
							@keydown-enter-prevent="authenticate"
							context="user"
							:action-name="actions.GET"
						></bee-text-field>
					</v-col>
				</v-row>

				<v-row style="width:100% !important;" align="center" justify="center" class="ma-0">
					<!-- password -->
					<v-col cols="auto" lg="3" class="py-lg-0">
						<bee-text-field
							v-model="password"
							:label="$t('Login.password')"
							:append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
							:type="showPass ? 'text' : 'password'"
							:rules="[rules.required]"
							@keydown-enter-prevent="authenticate"
							@click-append="showPass = !showPass"
							context="user"
							:action-name="actions.GET"
						></bee-text-field>
					</v-col>
				</v-row>

				<!-- login button -->
				<bee-btn
					:content="$t('Login.sign-in')"
					:color="valid ? 'primary' : 'blueGray'"
					:disabled="!valid"
					:loading="loading"
					outer-class="mt-3"
					@click="authenticate"
					context="user"
					:action-name="actions.GET"
				></bee-btn>

				<!-- login errors -->
				<div class="alert alert-danger mt-4" v-if="!loading && error">
					<span class="mb-0 text-center red--text">{{ error }}</span>
				</div>
			</v-form>
		</v-row>
	</v-container>
</template>

<script>
import ls from "../../settings/localStorageExtension";
import rules from "../../validation";
import { getError } from "../../helpers";
import { mapState } from "vuex";
import actions from "../../permissions/actions-names.js";
import { i18nSetLang } from '../../i18n/i18n';
import availableLangs from '../../settings/constants/availableLangs';
export default {
	data() {
		return {
			actions,
			username: null,
			password: null,
			loading: false,
			error: null,
			rules,
			valid: false,
			showPass: false,
		};
	},
	computed: {
		...mapState("financialFiles", ["financial_files"])
	},
	methods: {
		authenticate() {
			if (this.valid) {
				this.loading = true;
				this.$store.dispatch("auth/login", {
					user_name: this.username,
					password: this.password
				})
				.then(response => {
					this.error = null;
					const user = {
						id: response.id,
						user_name: response.user_name,
						is_admin: response.is_admin,
					};
					i18nSetLang(availableLangs.find(c => c.id === response.language)?.key ?? 'ar')
					ls.setLocalUser(JSON.stringify(user));
					this.$router.replace({ name: 'quick-financial-file-selector' })
				})
				.catch(e => {
					this.error = getError(e);
					this.loading = false;
				})
			}
		},
	},

	meta: {
		title: "login",

		meta: [{ property: "og:title", content: "login / mirta" }]
	}
};
</script>


<style scoped>
form {
	max-width: 320px;
	padding: 2rem;
}
</style>